export const updateObjectKeyAndValue = (object, objectSetter, key, value) => {
  const newValues = { ...object }
  newValues[key] = { ...newValues[key], 'value': value }
  objectSetter(newValues)
}